import { Box } from '@mui/material';
import { AttackPokemonData } from '../../types/attack';
import PokemonAbilitySelect from '../PokemonAbilitySelect';
import KodaiQuarkStatSelect from '../KodaiQuarkStatSelect';

interface AttackPokemonAbilityInputProps {
  attackPokemon: AttackPokemonData;
  handleSelectAbilityForAttackPokemon: (id: string, abilityId: number) => void;
  handleUpdateKodaiQuarkStat: (id: string, value: 'attack' | 'special_attack') => void;
}

function AttackPokemonAbilityInput({
  attackPokemon,
  handleSelectAbilityForAttackPokemon,
  handleUpdateKodaiQuarkStat,
}: AttackPokemonAbilityInputProps) {
  const shouldShowKodaiQuark =
    attackPokemon.selectedAbility?.name_ja === 'こだいかっせい' ||
    attackPokemon.selectedAbility?.name_ja === 'クォークチャージ';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <PokemonAbilitySelect
        pokemon={attackPokemon.pokemon}
        value={attackPokemon.selectedAbilityId}
        onChange={(abilityId) => handleSelectAbilityForAttackPokemon(attackPokemon.id, abilityId)}
        variant="sidebar"
        label="特性を選択"
        stopPropagation
      />

      {shouldShowKodaiQuark && (
        <KodaiQuarkStatSelect
          value={attackPokemon.kodai_quark_stat || 'attack'}
          onChange={(newValue) => handleUpdateKodaiQuarkStat(attackPokemon.id, newValue)}
          stopPropagation
        />
      )}
    </Box>
  );
}

export default AttackPokemonAbilityInput;
